export const NEW_NAV_V1 = "new_nav_1"
